import { render } from "./ModalContent.vue?vue&type=template&id=1f0dc30c&scoped=true&ts=true"
import script from "./ModalContent.vue?vue&type=script&lang=ts"
export * from "./ModalContent.vue?vue&type=script&lang=ts"

import "./ModalContent.vue?vue&type=style&index=0&id=1f0dc30c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0dc30c"]])

export default __exports__